<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'融资租赁申请审核',goback:true},{name:'融资租赁公司信息'}]" :title="'融资租赁公司信息'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基本信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">公司名称：</div>
                        <div class="content">{{companyInfo.companyName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">分类：</div>
                        <div class="content">{{companyInfo.classifyValue}}</div>
                    </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">LOGO：</div>
                        <div class="content"><img class="logos"  :src="companyInfo.logoUrl"></div>
                    </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="child">
                        <div class="name">公司简介：</div>
                        <div class="content">{{companyInfo.remarks}}</div>
                    </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="childMulti">
                        <div class="name">融资租赁说明：</div>
                        <ul>
                            <li class="content">{{companyInfo.explanation}}</li>
                        </ul>
                    </div>
                  </el-col>
                  </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content">
                            <li v-for="(item,i) in companyInfo.fileList" :key="i">
                                <span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i>
                            </li>
                        </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            companyInfo:{
                companyName:'',
                classifyValue:'',
                logoUrl:'',
                remarks:'',
                explanation:'',
                fileList:[]
            },
		
        }
    },
    methods:{
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosz.get('backstage/financial/leasing/details/'+this.id)
          if (code == 200) {            
              this.companyInfo = data
              this.companyInfo.logoUrl = this.companyInfo.frontPath+this.companyInfo.logoUrl
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>